import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CaixaDespesaFuncionarioMainComponent } from './caixa-despesa-funcionario-main/caixa-despesa-funcionario-main.component';
import { CaixaDespesaFuncionarioMovimentacoesComponent } from './caixa-despesa-funcionario-movimentacoes/caixa-despesa-funcionario-movimentacoes.component';
import { GlobalModule } from 'src/app/global/global.module';
import { ContaTevService } from 'src/app/base/services/conta-tev.service';
import { LancamentoDespesaService } from 'src/app/base/services/lancamento-despesa.service';

@NgModule({
  declarations: [CaixaDespesaFuncionarioMainComponent, CaixaDespesaFuncionarioMovimentacoesComponent],
  imports: [CommonModule, GlobalModule],
  providers: [LancamentoDespesaService, ContaTevService],
})
export class CaixaDespesaFuncionarioModule {}
